import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { fetchAndUpdateMsalConfig } from './config/authConfig';

// Loading component
const LoadingScreen = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    fontFamily: 'Arial, sans-serif'
  }}>
    <div>
      <h2>Loading configuration...</h2>
      <p>Please wait while we initialize the application.</p>
    </div>
  </div>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Show loading screen initially
root.render(<LoadingScreen />);

// Fetch MSAL configuration from backend and initialize app
(async () => {
  try {
    const config = await fetchAndUpdateMsalConfig();
    const msalInstance = new PublicClientApplication(config);
    
    // Render the app once config is loaded
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize application:', error);
    root.render(
      <div style={{ padding: '20px', color: 'red' }}>
        <h2>Failed to initialize application</h2>
        <p>Please check your configuration and try again.</p>
      </div>
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();